<template>
  <main class="sa-content">
      <div class="sa-card-large">
        <chat-with-doctor :callflag="callflag" />
      </div>
      <div class="sa-dialog sa-assegements" v-show="disconnectPopup"  >
        <div class="sa-dialog-body sa-small sa-text-center">
          <p>Your call will disconnect in one minute,Do you want to continue</p>
          <button class="sa-btn sa-btn-default sa-mr20"  @click="incrementChat">Yes</button>
            <button class="sa-btn sa-btn-default" @click="normalChat">No</button>
        </div>
    </div>
  </main>
</template>
<script>
import ChatWithDoctorVue from '../../components/chat/ChatWithDoctor.vue';
export default {
  components: {
      'chat-with-doctor': ChatWithDoctorVue
  },
  data() {
    return {
      disconnectPopup: false,
      callflag: false,
      popflag: false
    };
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    incrementChat(){
      this.callflag = true,
      this.disconnectPopup = false
      this.popflag = true
    },
    normalChat(){
      this.callflag = false,
      this.disconnectPopup = false
      this.popflag = true
    }
  },
  mounted() {
    this.toggleBodyClass('addClass', 'sa-chat-vdo');
  },
  destroyed() {
    this.toggleBodyClass('removeClass', 'sa-chat-vdo');
  },
};
</script>
